module.exports = __webpack_public_path__ + "static/diamond-desc-x2-6decc43d1f66806944c9d2bc56cc303f.png";